import { call, put, takeLatest } from 'redux-saga/effects';

import { handleSagaError } from '»utils/handleSagasError';
import { navigate } from '»utils/navigation';

import { menusSlice } from '../..';
import { authServices } from './auth.services';
import { authSlice } from './auth.slice';

const getUserProcessWorker = function* ({ payload }) {
  try {
    const { processId } = payload;

    const data = yield call(authServices.getUserProcess, {
      processId,
    });

    yield put(
      authSlice.actions.getUserProcessSuccess({
        processId,
        value: data[0].optionId,
      }),
    );

    if (data[0].optionId === 'Y') {
      navigate('/Dashboard');
      yield put(
        menusSlice.actions.setActiveMenuItem({ activeMenuItem: 'DASHBOARD' }),
      );
    }
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled) yield put(authSlice.actions.getUserProcessFailure());
  }
};

export const authSagas = function* () {
  yield takeLatest(
    authSlice.actions.getUserProcessRequest.type,
    getUserProcessWorker,
  );
};
